import { pipe } from 'ramda';
import { useGetCourseTimetableQuery } from '../../../services/generated/studentPortalApi';
import { useTimetableItems } from '@versita/frontend/timetable-hooks';

/**
 * Fetches course timetable events, converts them to the props expected by the
 * Timetable component and groups them by week day.
 */
export const useCourseTimetableEvents = pipe(
  useGetCourseTimetableQuery,
  useTimetableItems,
);
